import * as budgetAPI from '../../lib/api/budget'
import {fetchBalances, fetchSavingStreams} from './balances'
import * as loadingActions from './loading'
import WS from '../../lib/websocket'
import * as activity from '../../lib/util/activity'
import moment from 'moment'

export const BUDGET_HEALTH = 'BUDGET_HEALTH'
export const BUDGET_WITHDRAWAL_CONFIGURATION = 'BUDGET_WITHDRAWAL_CONFIGURATION'
export const BUDGET_UPDATE_PENDING_WITHDRAWALS = 'BUDGET_UPDATE_PENDING_WITHDRAWALS'
export const BUDGET_CANCEL_PENDING_WITHDRAWAL = 'BUDGET_CANCEL_PENDING_WITHDRAWAL'
export const BUDGET_TRANSFER_DESTINATIONS = 'BUDGET_TRANSFER_DESTINATIONS'
export const BUDGET_UPDATE_UPCOMING_ACTIVITY = 'BUDGET_UPDATE_UPCOMING_ACTIVITY'

export const BUDGET_UPDATE_INCOME = 'BUDGET_UPDATE_INCOME'
export const BUDGET_VERIFY_INCOME = 'BUDGET_VERIFY_INCOME'

export const BUDGETING_UPDATE_UPCOMING_ACTIVITY_TAB = 'BUDGETING_UPDATE_UPCOMING_ACTIVITY_TAB'
export const BUDGET_UPDATE_TWELVE_MONTH = 'BUDGET_UPDATE_TWELVE_MONTH'
export const BUDGET_GET_UPCOMING_INCOME = 'BUDGET_GET_UPCOMING_INCOME'
export const BUDGET_GET_UPCOMING_BPAY = 'BUDGET_GET_UPCOMING_BPAY'
export const BUDGET_GET_UPCOMING_ON_HOLD = 'BUDGET_GET_UPCOMING_ON_HOLD'

function _updateBudgetHealth(healthIndex){
	return {
		type: BUDGET_HEALTH,
		healthIndex: healthIndex
	}
}

function _setTransferDestinations(destinations){
	return {
		type: BUDGET_TRANSFER_DESTINATIONS,
		transferDestinations: destinations
	}
}

/**
 * Fetch budget health
 * @returns {function(): (Promise.<T>|Promise.<T>)}
 */
export function getBudgetHealth(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_HEALTH,
			budgetAPI.health().then(health => {
				dispatch(_updateBudgetHealth(health))
				return health
			})
		)
}

export function loadWithdrawalConfiguration(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_WITHDRAWAL_CONFIGURATION,
			budgetAPI.getWithdrawalServiceStatus().then(config => {
				dispatch(_setWithdrawalConfiguration(config))
				return config
			})
		)
}

function _setWithdrawalConfiguration(status){
	return {
		type: BUDGET_WITHDRAWAL_CONFIGURATION,
		config: status
	}
}

export function getPendingWithdrawals(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_UPDATE_PENDING_WITHDRAWALS,
			budgetAPI.getPendingTransfers().then(withdrawals => {
				dispatch(_setPendingWithdrawals(withdrawals))
				return withdrawals
			})
		)
}

function _setPendingWithdrawals(withdrawals){
	return {
		type: BUDGET_UPDATE_PENDING_WITHDRAWALS,
		withdrawals: withdrawals
	}
}

export function cancelPendingTransaction(transferId){
	return (dispatch) => loadingActions.promise(
		dispatch,
		[BUDGET_CANCEL_PENDING_WITHDRAWAL, transferId],
		budgetAPI.cancelPendingTransfer(transferId)
			.then((id) => WS.waitFor(id))
			.then(() => dispatch(_cancelPendingTransfer(transferId)))

	).then(() => Promise.all([ // Update balances incase the cancel has affected the balances
		dispatch(fetchBalances()),
		dispatch(fetchSavingStreams())
	]))
}

function _cancelPendingTransfer(id){
	return {
		type: BUDGET_CANCEL_PENDING_WITHDRAWAL,
		id: id
	}
}

export function getTransferDestinations(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_TRANSFER_DESTINATIONS,
			budgetAPI.getTransferDestinations().then(data => {
				dispatch(_setTransferDestinations(data))
				return data
			})
		)
}

/**
 * Fetches the upcoming activity
 * @param count
 * @param offset
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function getUpcomingActivity(count, offset){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_UPDATE_UPCOMING_ACTIVITY,
			budgetAPI.getUpcomingActivity(count, offset).then(response => {
				dispatch(_setUpcomingActivity(response.activities, response.activitiesUpdated ? 0 : offset))
				return response
			})
		)
}

function _setUpcomingActivity(activity, offset){
	return {
		type: BUDGET_UPDATE_UPCOMING_ACTIVITY,
		upcomingActivity: activity,
		pageOffset: offset
	}
}

/**
 * Updates
 * @param tab
 * @return {{type: *, tab: *}}
 */
export function changeUpcomingActivityTab(tab){
	return {
		type: BUDGETING_UPDATE_UPCOMING_ACTIVITY_TAB,
		tab: tab
	}
}

export function updateIncome(id, amount, dateExpected){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_UPDATE_INCOME,
			budgetAPI.updateIncome(id, amount, dateExpected)
				.then((id) => WS.waitFor(id))
		)
}

export function verifyIncome(id){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			[BUDGET_VERIFY_INCOME, id],
			budgetAPI.verifyIncome(id)
				.then((id) => WS.waitFor(id))
				.then(() => dispatch(_verifyIncome(id)))
		)
}

function _verifyIncome(id){
	return {
		type: BUDGET_VERIFY_INCOME,
		id: id
	}
}

/**
 * Fetches Upcoming Activity on hold BPayments
 * @param month
 * @param year
 * @param concat
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function getUpcomingActivityBPay(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_GET_UPCOMING_BPAY,
			budgetAPI.getUpcomingActivityBPay()
				.then((payments) => dispatch(_setUpcomingActivityBPay(payments)))
		)
}

/**
 * @param payments
 * @return {{type: string, payments: *}}
 * @private
 */
export function _setUpcomingActivityBPay(payments){
	return {
		type: BUDGET_GET_UPCOMING_BPAY,
		payments: payments
	}
}

/**
 * Fetches Upcoming Income Activity
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function getUpcomingActivityIncome(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_GET_UPCOMING_INCOME,
			budgetAPI.getUpcomingActivityIncome()
				.then((incomes) => dispatch(_setUpcomingActivityIncome(incomes)))
		)
}

/**
 * @param incomes
 * @return {{type: string, incomes: *}}
 * @private
 */
export function _setUpcomingActivityIncome(incomes){
	return {
		type: BUDGET_GET_UPCOMING_INCOME,
		incomes: incomes
	}
}

/**
 * get the recommended payment date based on the payment method.
 * @param paymentMethod
 * @param requestedDate
 */
export function getRecommendedPaymentDate(paymentMethod, requestedDate){
	// BPay (B) = same day
	// Direct Credit (D) = 1 day prior
	// Cheque (C) = 7 days prior
	const date = requestedDate instanceof Date ? requestedDate : moment.utc(requestedDate, 'DD-MM-YYYY').toDate()

	if(paymentMethod == 'D') return {recommended: activity.priorWorkday(date), prior: 1, formatted: moment.utc(activity.priorWorkday(date)).format('DD-MM-YYYY')}
	if(paymentMethod == 'C') return {recommended: activity.priorWorkday(date, 7), prior: 7, formatted: moment.utc(activity.priorWorkday(date, 7)).format('DD-MM-YYYY')}

	return {recommended: date, prior: 0, formatted: moment.utc(date).format('DD-MM-YYYY')}
}

/**
 * Fetches Twelve Month Activity
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function getTwelveMonth(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_UPDATE_TWELVE_MONTH,
			budgetAPI.getTwelveMonthBudget()
				.then((report) => dispatch(_setTwelveMonth(report)))
		)
}

/**
 * Updates the redux store for the twelve month report
 * @param report
 * @return {{type: string, incomes: *}}
 * @private
 */
export function _setTwelveMonth(report){
	return {
		type: BUDGET_UPDATE_TWELVE_MONTH,
		twelveMonth: report
	}
}

/**
 * Fetches Upcoming On Hold Activity
 * @param month
 * @param year
 * @param concat
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function getUpcomingActivityOnHold(){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_GET_UPCOMING_ON_HOLD,
			budgetAPI.getUpcomingActivityOnHold()
				.then((payments) => dispatch(_setUpcomingActivityOnHold(payments)))
		)
}

/**
 * @param payments
 * @return {{type: string, payments: *}}
 * @private
 */
export function _setUpcomingActivityOnHold(payments){
	return {
		type: BUDGET_GET_UPCOMING_ON_HOLD,
		payments: payments
	}
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/budgeting.js